module.exports = __webpack_public_path__ + "img/matt_d_2.81e3b49f.png";